import React, { useContext } from 'react';
import './background.css';
import { ColorsContext } from '../colorContext';
export default function Background(){
    const {colors} = useContext(ColorsContext);
    return (
        <>
            <div style={{backgroundColor: colors.COLOR_BODY}} className="background">
                {Array.from({ length: 50 }).map((_, index) => (
                    <span key={index}></span>
                ))}
            </div>
        </>
    );
}